import logo from './logo.svg';
import './App.css';
import CustomizeScreen from './components/customizeScreen/customizeScreen.component';
function App() {
  return (
    <div className="App">
      <CustomizeScreen />
    </div>
  );
}

export default App;
